module.exports = __webpack_public_path__ + "img/login-bg.b4fedf5e.svg";